import { CreateFormGrid } from 'ui/ManagerFinance/components'
import { meterInvoiceBasicInformationInputs } from './constants'
import MeterInvoiceFormInput from './MeterInvoiceFormInput'

const BasicInformationForm = () => {
	return (
		<CreateFormGrid>
			{meterInvoiceBasicInformationInputs.map((input) => {
				return <MeterInvoiceFormInput key={input.key} input={input} />
			})}
		</CreateFormGrid>
	)
}

export default BasicInformationForm
